// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://msvzydcnhumxthhjkycg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1zdnp5ZGNuaHVteHRoaGpreWNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQzMDA0MjEsImV4cCI6MjA2OTg3NjQyMX0.gfzse6TGN7HOBwTLJowLlYy1ghhfSZtvAThTV_DQGUc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
